import WOW from "wow.js" 

window.addEventListener('load', () => {

  new WOW({
    offset: -10
  }).init()

  if(window.innerWidth < 989){
    return
  }
  
  const contentBoxElements = document.querySelectorAll('.content-box')
  const inquiryBoxElements = document.querySelectorAll('.inquiry-box')

  applyAnimationToElements(contentBoxElements)
  applyAnimationToElements(inquiryBoxElements)
})

function applyAnimationToElements(elements) {

  let delay = 0

  elements.forEach(function (element) {
    // 横並びがある要素のみ遅延時間を設定
    const wowElements = element.querySelectorAll('.wow.fadeInUp.-list')
    delay = applyAnimationWithDelay(wowElements, delay)
    delay = 0
  })
}

function applyAnimationWithDelay(elements, delay) {
  elements.forEach(function (element) {
    const computedStyle = window.getComputedStyle(element)
    if (computedStyle.getPropertyValue('display') !== 'none') {
      element.style.animationDelay = delay + 's'
      delay += 0.1
    }
  })
  return delay
}